"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _draftExtend = require("draft-extend");

var _constants = require("composer-plugins/lib/constants");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _ImageComponent = _interopRequireDefault(require("./ImageComponent"));

var BLOCK_TYPE = 'atomic';
var DISPLAY_NAME = 'ImagePlugin';
var ENTITY_KEY = _constants.ENTITY_TYPES.image;

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fileManagerUploadedFileAccess = options.fileManagerUploadedFileAccess,
      _options$imageButtonB = options.imageButtonBuilder,
      imageButtonBuilder = _options$imageButtonB === void 0 ? function () {
    return null;
  } : _options$imageButtonB;

  var createEntityOptions = function createEntityOptions(src, name) {
    return [ENTITY_KEY, 'IMMUTABLE', {
      src: src,
      name: name
    }];
  };

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (!(0, _draftHelpers.isCorrectBlockTypeAndSize)(currentBlock, BLOCK_TYPE)) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (entity && entity.getType() === ENTITY_KEY) {
        return {
          component: _ImageComponent.default,
          editable: false,
          props: props
        };
      }

      return undefined;
    };
  };

  var htmlToBlock = function htmlToBlock(nodeName, node, lastList, inBlock) {
    if (nodeName === 'figure' && node.firstChild.nodeName === 'IMG' || nodeName === 'img' && inBlock !== 'atomic') {
      return BLOCK_TYPE;
    }

    return undefined;
  };

  var htmlToEntity = function htmlToEntity(nodeName, node, createEntity) {
    if (nodeName === 'img') {
      return createEntity.apply(void 0, (0, _toConsumableArray2.default)(createEntityOptions(node.getAttribute('src'), node.getAttribute('alt'))));
    }

    return undefined;
  };

  var entityToHTML = function entityToHTML(entity, originalText) {
    if (entity.type === ENTITY_KEY) {
      var _entity$data = entity.data,
          src = _entity$data.src,
          name = _entity$data.name;
      return "<img src=\"" + src + "\" alt=\"" + name + "\" />";
    }

    return originalText;
  };

  var blockToHTML = {
    atomic: {
      start: '<div>',
      end: '</div>'
    }
  };
  return (0, _draftExtend.createPlugin)({
    displayName: DISPLAY_NAME,
    buttons: imageButtonBuilder(fileManagerUploadedFileAccess),
    blockRendererFn: blockRendererFn(options),
    htmlToBlock: htmlToBlock,
    htmlToEntity: htmlToEntity,
    entityToHTML: entityToHTML,
    blockToHTML: blockToHTML
  });
};

exports.default = _default;
module.exports = exports.default;